import { z } from 'zod/v4';
import { Lang } from '../../lang/Lang.js';
import { TemplateType } from '../../templates/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
export var MentionCategory;
(function (MentionCategory) {
    MentionCategory["Debtor"] = "debtor";
    MentionCategory["Creditor"] = "creditor";
    MentionCategory["Case"] = "case";
    MentionCategory["Contact"] = "contact";
    MentionCategory["Collector"] = "collector";
    MentionCategory["Financials"] = "financials";
    MentionCategory["Accord"] = "accord";
    MentionCategory["PaymentPlan"] = "payment_plan";
    MentionCategory["Dates"] = "dates";
    MentionCategory["User"] = "user";
    MentionCategory["Court"] = "court";
    MentionCategory["Tribunal"] = "tribunal";
    MentionCategory["Conditionals"] = "conditionals";
    MentionCategory["Other"] = "other";
})(MentionCategory || (MentionCategory = {}));
const filtersSchema = z.object({
    templateType: z
        .enum(TemplateType)
        .default(TemplateType.EMAIL)
        .describe('The type of interaction we are planning to do. Defaults to EMAIL — set explicitly for SMS or LETTER which expose different mention sets (e.g. QR codes only make sense for letters).'),
    language: z
        .enum(Lang)
        .default(Lang.da)
        .describe('Language of the enum labels and descriptions. Defaults to da (Danish). Set to the debtor/creditor recipient language when authoring the body so labels match.'),
    category: z
        .enum(MentionCategory)
        .optional()
        .describe('Scope to one category. Call with no filters to see all.'),
});
const itemSchema = z.object({
    handle: z.string(),
    label: z.string(),
    category: z.enum(MentionCategory),
    description: z.string(),
});
const facetsSchema = z.object({
    byCategory: z.record(z.enum(MentionCategory), z.number().int()),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchMentionsTool = {
    name: ToolName.SearchMentions,
    category: ToolCategory.Templates,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Search the catalog of {{mention}} placeholders that resolve at send time when an interaction body is rendered. The catalog is global and stable for the run — call ONCE per category you need (or once with no args to see the whole shape via facets), not repeatedly for variations. Use returned handles VERBATIM as placeholders in the body of create_interaction; do not paraphrase or strip the braces. Categories: debtor / creditor / case / contact / collector / financials / accord / payment_plan / dates / user / court / tribunal / conditionals / other.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-mentions.js.map